module.exports = __webpack_public_path__ + "static/assets/f8e29036af486af72dd0babac694aa11.svg";